import {
  GetNotificationsListResponse,
  NotificationStatus,
} from '@/fsd/entities/notifications/model/types/types';
import {
  InfiniteData,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { putNotificationRead } from '../../api/putNotificationRead/putNotificationRead';

interface MutateNotificationProps {
  action: 'mark_read' | 'archive';
  target: 'single' | 'all';
  notification_id?: number;
}

interface IParams {
  status?: NotificationStatus;
}

export const useNotificationRead = ({ status: queryStatus }: IParams) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (props: MutateNotificationProps) => putNotificationRead(props),
    onSuccess: (_, { action, target, notification_id }) => {
      if (target === 'single' && notification_id) {
        queryClient.setQueryData<InfiniteData<GetNotificationsListResponse>>(
          ['notifications', queryStatus],
          (oldData) => {
            if (!oldData) return oldData;

            return {
              ...oldData,
              pages: oldData.pages.map((page) => ({
                ...page,
                data: page.data.map((n) =>
                  n.notification_id === notification_id
                    ? { ...n, status: 'read' }
                    : n
                ),
              })),
            };
          }
        );
        queryClient.refetchQueries({
          queryKey: ['notification-count'],
        });
      } else if (target === 'all' && action === 'mark_read') {
        queryClient.refetchQueries({
          queryKey: ['notifications'],
        });
        queryClient.refetchQueries({
          queryKey: ['notification-count'],
        });
      }
    },
  });

  return { readNotification: mutate, isPending };
};
